import { render, staticRenderFns } from "./ToggleWholesalable.vue?vue&type=template&id=27facf62&scoped=true"
import script from "./ToggleWholesalable.vue?vue&type=script&lang=js"
export * from "./ToggleWholesalable.vue?vue&type=script&lang=js"
import style0 from "./ToggleWholesalable.vue?vue&type=style&index=0&id=27facf62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27facf62",
  null
  
)

export default component.exports